import { FormHelpers } from "../helpers/FormHelpers";
export class GetBrochure {
    constructor() {
        this.modal = document.querySelector('#get-brochure-modal');
        this.openModalButtons = document.querySelectorAll('.get-brochure-button');
        this.steps = document.querySelectorAll('.get-brochure-form .step');
        this.currentStep = 0;
        this.form = document.querySelector('#get-brochure-form');
        this.formHelper = new FormHelpers();
        this.canSubmit = true;
        if (!this.modal)
            return;
        this.closeModalButtons = this.modal.querySelectorAll('[data-close]');
        this.submitButton = this.modal.querySelector('[type="submit"]');
        if (!this.form)
            return;
        this.init();
    }
    init() {
        const self = this;
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            if (!self.canSubmit)
                return;
            self.canSubmit = false;
            this.submitButton.classList.add('is-active');
            self.submitForm();
        });
        this.openModalButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                self.modal.classList.add('show');
            });
        });
        this.closeModalButtons.forEach((button) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                self.modal.classList.remove('show');
                self.resetModal();
            });
        });
    }
    submitForm() {
        if (!this.formHelper.validateForm(this.form)) {
            this.canSubmit = true;
            this.submitButton.classList.remove('is-active');
            return;
        }
        const self = this;
        const formData = new FormData(this.form);
        const options = {
            method: 'POST',
            contentType: 'application/x-www-form-urlencoded',
            body: formData,
        };
        fetch(window.localize_script.admin_ajax, options).
            then(response => response.json())
            .then(response => {
            self.canSubmit = true;
            self.submitButton.classList.remove('is-active');
            if (response.success) {
                self.nextStep();
            }
            console.log(response);
        })
            .catch(error => {
            console.error(error);
        });
    }
    nextStep() {
        this.steps[this.currentStep].classList.remove('active');
        this.currentStep++;
        this.steps[this.currentStep].classList.add('active');
    }
    resetModal() {
        this.steps.forEach((step) => {
            step.classList.remove('active');
        });
        this.currentStep = 0;
        this.steps[this.currentStep].classList.add('active');
    }
}
